<!-- 资讯、办事大厅导航栏 -->
<template>
  <div :class="mobileClass('cm_newsNav_container')">
    <div class="cm_newsNav_title">
      <img src="@/assets/img/title-icon.png" />
      <span>{{ele.title}}</span>
    </div>
    <el-menu
      :default-active="$router.path"
      class="el-menu-vertical-demo"
      router
      @select="handleSelect"
    >
      <div v-for="item in ele.children" :key="item.id" v-show="hasAlias(webConfigue, item.data)">
        <el-submenu
          :index="item.path"
          :route="item.fullPath"
          class="cm_newsNav_option"
          v-if="item.children!=''&&item.children!=undefined"
        >
          <template slot="title">
            <span class="cm_newsNav_name">{{item.title}}</span>
          </template>
          <el-menu-item
            :index="child.path"
            :route="child.fullPath"
            v-for="child in (item.children)"
            :key="child.id"
          v-show="hasAlias(webConfigue, child.data)">
            <img src="@/assets/img/active-flag.png" v-if="activePath == child.path" class="fl" />
            <span slot="title" class="cm_newsNav_name">{{child.title}}</span>
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="item.path" :route="item.fullPath" v-if="item.children==''||item.children==undefined">
          <img src="@/assets/img/active-flag.png" v-if="activePath == item.path" class="fl" />
          <span slot="title" class="cm_newsNav_name">{{item.title}}</span>
        </el-menu-item>
      </div>
    </el-menu>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      activePath: window.localStorage.getItem("activePath")?window.localStorage.getItem("activePath"):"",
      ele: "",
      webConfigue: JSON.parse(window.localStorage.getItem("webConfigue")),
      windowWidth:document.documentElement.clientWidth
    };
  },
  //监听属性 类似于data概念
  computed: {
     mobileClass(){
       return (val)=>{
         if(this.windowWidth > 500) {
          return val
          } else {
            return "mobile_"+val
          }
       }
    },
  },
  //监控data中的数据变化
  watch: {
    '$store.state.screenWidth': function (val) { //监听屏幕宽度变化
    this.windowWidth = val;
  }
  },
  //方法集合
  methods: {
    hasAlias: function (arr, alias1) {
      let alias = ""
      if (alias1 != "" && alias1 != undefined && alias1 != null) {
        alias = alias1.channelId
        for (let i = 0; i < arr.length; i++) {
          if (
            arr[i][this.ele.alias] != "" &&
            arr[i][this.ele.alias] != undefined &&
            arr[i][this.ele.alias] != null
          ) {
            for (let j = 0; j < arr[i][this.ele.alias].length; j++) {
              if (arr[i][this.ele.alias][j].TEMPLATE_ID == alias) {
                return true;
              }
            }
          }
        }
        return false
      }else{
        return true
      }
      
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
      this.activePath = key;
      window.localStorage.setItem("activePath",this.activePath)
    },

    loadItem() {
      let navList = this.$store.state.comData.navList;
      for (let i = 0; i < navList.length; i++) {
        if (this.$route.path.indexOf(navList[i].path) == 0) {
          this.ele = navList[i];
          this.activePath = this.ele.children[0].path;
        }
      }
    },

  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.loadItem();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.activePath = window.localStorage.getItem("activePath")
  },
  updated() {

  }

};
</script>
<style>
.cm_newsNav_container {
  width: 380px;
}
.cm_newsNav_title {
  width: 100%;
  height: 40px;
  background: #f2f3f4;
  display: flex;
  align-items: center;
}
.cm_newsNav_title > span {
  font-size: 20px;
  font-weight: 600;
  color: #4278d2;
}
.cm_newsNav_name {
  margin-left: 50px;
  font-size: 16px;
}
/* .el-icon-arrow-down:before {
    content: none!important;
} */
.el-menu-item.is-active {
  color: #4278d2!important;
  font-weight: 600;
}
.el-menu-item:hover, .el-menu-item:focus{
  background-color: #f2f3f4!important;
}

.el-submenu__title:hover{
  background-color: #f2f3f4!important;
}
.mobile_cm_newsNav_container{
  width: 100%;
}
.mobile_cm_newsNav_container>.cm_newsNav_container{
  width: 100%;
}
</style>